import React, { useContext, useEffect, useState } from "react";
import { Button, ColorPicker, Form, Input, Space, Tag } from "antd";
import { IconPicker } from "react-fa-icon-picker";
import ModalTags from "../GeoUnit/ModalTags";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import TextEditorModal from "./../Place/TextEditorModal";
const LinkForm = () => {
    const [form] = Form.useForm();
    // state
    const [isEditSelected, setIsEditSelected] = useState(false);
    const [inputTitleStyle, setInputTitleStyle] = useState({
        width: "100%",
        outline: "0",
    });

    // context
    const {
        selectedLinkId,
        setLinkestanTags,
        setTextEditorShow,
        setTextEditorHTML,
        linkTitle,
        setLinkTitle,
        newLinks,
        setNewLinks,
        linkColor,
        setLinkColor,
        linkIcon,
        setLinkIcon,
        linkUrl,
        setLinkUrl,
        setLinkMedia,
        setLinkCover,
        linkestanIcon,
        setLinkestanIcon,
        titleOfLink,
        setTitleOfLink,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        if (selectedLinkId) {
            http.get(`${config.parkopoloApi}/api/Link/${selectedLinkId}`)
                .then((res) => {
                    setNewLinks(res.data.result.links);
                    setLinkTitle(res.data.result.title);
                    setLinkestanTags(res.data.result.tags);
                    setTextEditorHTML(res.data.result.data);
                    setLinkCover([res.data.result.coverPic]);
                    setLinkMedia(res.data.result.media);
                    setLinkestanIcon(res.data.result.icon);
                })
                .catch((err) => {
                    console.log(err);
                });
            setIsEditSelected(true);
        }
    }, []);
    // functions
    const handleDeleteLink = (url) => {
        const links = newLinks.filter((link) => link.url !== url);
        setNewLinks(links);
    };
    const handleTitleChange = (e) => {
        setLinkTitle(e.target.value);
    };
    const handleColorChange = (color) => {
        setLinkColor(color);
    };
    const handleIconChange = (e) => {
        setLinkIcon(e);
    };
    const handleLinkestanIconChange = (e) => {
        setLinkestanIcon(e);
    };
    const onUrlChange = (e) => {
        setLinkUrl(e.target.value);
    };
    const onTitleOfLinkChange = (e) => {
        setTitleOfLink(e.target.value);
    };
    const handleAddLink = () => {
        const color = document.querySelector(
            ".ant-color-picker-trigger-text"
        ).innerText;
        const newLink = {
            name: titleOfLink,
            url: linkUrl,
            color: color,
            icon: linkIcon,
        };
        setNewLinks([...newLinks, newLink]);
        setLinkUrl(null);
        setLinkColor("#000");
        setLinkIcon(null);
        setTitleOfLink(null);
    };
    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div style={{ display: "flex", gap: "2rem" }}>
                    <Form.Item
                        name="عنوان"
                        label="عنوان"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {linkTitle}
                        </h4>
                        <input
                            style={inputTitleStyle}
                            className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                            type="text"
                            value={isEditSelected ? linkTitle : null}
                            onChange={handleTitleChange}
                            placeholder="عنوان را وارد کنید"
                            onFocus={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "1px solid #48D1CC",
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                            onBlur={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "",
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                            onMouseEnter={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                            onMouseLeave={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="آیکون"
                        label="آیکون"
                        style={{ width: "100%" }}
                    >
                        <IconPicker
                            value={linkestanIcon}
                            buttonStyles={{
                                padding: "0 2.5rem",
                                border: "1px solid silver",
                                width: "100%",
                            }}
                            onChange={(e) => handleLinkestanIconChange(e)}
                        />
                        <h4>{linkestanIcon?.slice(2)}</h4>
                    </Form.Item>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "30px",
                        alignItems: "center",
                    }}
                >
                    <Form.Item
                        name="عنوان لینک"
                        label="عنوان لینک"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {titleOfLink}
                        </h4>
                        <Input
                            value={titleOfLink}
                            onChange={onTitleOfLinkChange}
                            placeholder="عنوان لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item
                        name="آدرس لینک"
                        label="آدرس لینک"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {linkUrl}
                        </h4>
                        <Input
                            value={linkUrl}
                            onChange={onUrlChange}
                            placeholder="آدرس لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item label="آیکون لینک" name="آیکون لینک">
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {linkIcon}
                        </h4>
                        <IconPicker
                            value={linkIcon}
                            buttonStyles={{
                                padding: "0 2.5rem",
                                border: "1px solid silver",
                                width: "100%",
                            }}
                            onChange={(e) => handleIconChange(e)}
                        />
                    </Form.Item>
                    <Form.Item label="رنگ لینک" name="رنگ">
                        <ColorPicker
                            value={linkColor}
                            onChange={handleColorChange}
                            style={{
                                padding: "1.5rem",
                                width: "100%",
                            }}
                            showText
                        />
                    </Form.Item>
                    <Button
                        onClick={handleAddLink}
                        disabled={
                            !titleOfLink ||
                            titleOfLink === "" ||
                            !linkColor ||
                            !linkIcon ||
                            linkUrl.slice(0, 8) !== "https://"
                        }
                    >
                        اضافه کردن لینک جدید
                    </Button>
                </div>
                <Space wrap>
                    {newLinks.map((link) => {
                        return (
                            <Tag
                                color="blue"
                                closeIcon
                                key={link.url}
                                onClose={() => handleDeleteLink(link.url)}
                            >
                                {link.url}{" "}
                                <i
                                    className={`fa ${link.icon
                                        .split(/(?=[A-Z])/)
                                        .map((word) => word.toLowerCase())
                                        .join("-")}`}
                                    style={{ fontSize: "10px" }}
                                />
                            </Tag>
                        );
                    })}
                </Space>

                <Form.Item name="تگ" label="تگ ها">
                    <div>
                        <ModalTags section="linkestan" />
                    </div>
                </Form.Item>
                <Form.Item name="ویرایشگر متن">
                    <Button
                        onClick={() => setTextEditorShow(true)}
                        type="primary"
                    >
                        ویرایشگر متن
                    </Button>
                </Form.Item>
            </Form>
            <TextEditorModal />
        </div>
    );
};

export default LinkForm;
